// extracted by mini-css-extract-plugin
module.exports = {"heading":"partners_heading__5KOJV","logos":"partners_logos__XnbDx"};